import { API_ENDPOINTS } from "config/config";
import { buildTableDateFilterParams } from "utils/dateRangeParams";

export const buildSalesQueryParams = ({ page, limit, search, filters }) => {
  const params = { page, limit };

  if (search?.productName) params.productName = search.productName;
  if (search?.stripeCustomerId) params.stripeCustomerId = search.stripeCustomerId;
  if (search?.stripePaymentIntentId) params.stripePaymentIntentId = search.stripePaymentIntentId;
  if (search?.utmSource) params.utmSource = search.utmSource;

  Object.assign(params, buildTableDateFilterParams(filters));

  if (filters?.status) params.status = filters.status;
  if (filters?.saleType) params.saleType = filters.saleType;
  if (filters?.source) params.source = filters.source;

  return params;
};

export const fetchSales = async (api, { page, limit, search, filters }) => {
  const params = buildSalesQueryParams({ page, limit, search, filters });
  const response = await api.get(API_ENDPOINTS.GET_SALES, { params });
  return response.data.data;
};

export const fetchSalesSummary = async (api, { filters }) => {
  const params = buildTableDateFilterParams(filters);
  const response = await api.get(API_ENDPOINTS.GET_SALES_SUMMARY, { params });
  return response.data.data;
};

export const fetchSaleById = async (api, id) => {
  const response = await api.get(`${API_ENDPOINTS.GET_SALES_BY_ID}/${id}`);
  return response.data.data;
};

export const fetchAllSales = async (api, { search, filters }) => {
  const firstPage = await fetchSales(api, { page: 1, limit: 1, search, filters });
  const total = firstPage.count || 0;
  if (total === 0) return [];

  const result = await fetchSales(api, { page: 1, limit: total, search, filters });
  return result.records || [];
};

export const createSale = async (api, payload) => {
  const response = await api.post(API_ENDPOINTS.CREATE_SALES, payload);
  return response.data.data ?? response.data;
};

export const updateSale = async (api, saleId, payload) => {
  const response = await api.put(
    `${API_ENDPOINTS.UPDATE_SALES}/${saleId}`,
    payload,
    { showLoader: false }
  );
  return response.data.data ?? response.data;
};

export const updateSaleCommission = async (api, saleId, payload) => {
  const response = await api.patch(
    `${API_ENDPOINTS.UPDATE_SALE_COMMISSION}/${saleId}/commission`,
    payload,
    { showLoader: false }
  );
  return response.data.data ?? response.data;
};
